import styled, { css, DefaultTheme } from "styled-components";

import Spring from "../../components/Spring";

export const StyledHomework = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - 50px);
    padding: 20px 40px 0;
    ${p =>
        p.theme.xs(css`
            padding: 0 16px;
        `)}
    h1 {
        ${p =>
        p.theme.xs(css`
                text-align: center;
            `)}
    }

    p {
        font-size: 18px;
    }

    ul {
        li {
            line-height: 1.5;
        }
    }
`;

export const StyledForm = styled.div`
    margin: auto;
    margin-top: 20px;
`;

export const PageContainer = styled.div`
    display: flex;
`;

export const Left = styled.div`
    flex: 1;
    h3 {
      margin: 0;
    }
    ${p =>
        p.theme.xs(css`
            width: 100%;
        `)}

    ${p =>
        p.theme.lg(css`
            [class^="styles__Page"] {
                width: 150px;
            }
        `)}
`;

export const AdDesktopRight = styled.div`
    width: 340px;
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
    margin-left: 40px;
`;

export const AdDesktopBottom = styled.div`
    margin-bottom: 20px;
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;

export const AdDesktopMiddle = styled.div`
    margin-top: 20px;
    margin-bottom: 10px;

    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;

export const AdMobileBottom = styled.div`
    margin: 0 -16px 20px;
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;

export const AdMobileTop = styled.div`
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;

export const AdMobileMiddle = styled.div`
    margin: 20px -16px 10px;
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;

export const FlexForm = styled.div`
    ${p =>
        p.theme.lg(css`
            display: flex;
            flex-direction: row;
            align-items: center;

            > div {
                flex: 1;
            }

            > * {
                margin-top: 20px;
            }

            > div:first-child {
                margin-right: 12px;
                margin-top: 0;
            }

            button {
                width: 120px;
                margin-left: 12px;
            }
            .FakeBack {
                visibility: hidden;
            }
        `)}
    ${p =>
        p.theme.md.max(css`
            .FakeBack {
                display: none;
            }
        `)}
`;

// lg: 765
// gap: 20
const gap = 20;
const totalItems = 6;
const lgWidth = 765 - 40;
const lgVisibleItems = 2;
const mdWidth = 557;
const mdVisibleItems = 2;
const smWidth = 333;

export const getAttentionTranslateX = (currentIndex: number, theme: DefaultTheme) => {
    if (!process.env.WEBPACK) return 0;
    let cardWidth = (lgWidth - gap) / 2 + gap;
    if (window.innerWidth < theme.$screenXsMax) {
        cardWidth = window.innerWidth;
    } else if (window.innerWidth < theme.$screenSmMax) {
        cardWidth = smWidth + gap;
    } else if (window.innerWidth < theme.$screenMdMax) {
        cardWidth = (mdWidth - gap) / mdVisibleItems + gap;
    }
    return -cardWidth * currentIndex;
}

export const AttentionScroll = styled.div`
  width: ${lgWidth}px;
  margin: 0 -16px;
  padding: 20px 16px;
  overflow: hidden;

  ${p => p.theme.md.only(css`
    width: ${mdWidth}px;
  `)}
  ${p => p.theme.sm.only(css`
    width: ${smWidth}px;
  `)}
  
  ${p => p.theme.xs(css`
      width: 100vw;
      padding: 10px 16px;
      margin: 0 -16px;
  `)}
  
`;

export const AttentionList = styled.div`
  display: flex;
  width: ${(lgWidth - gap) / lgVisibleItems * totalItems + gap * (totalItems - 1)}px;
  ${p => p.theme.md.only(css`
    width: ${(mdWidth - gap) / mdVisibleItems * totalItems + gap * (totalItems - 1)}px;
  `)}
  ${p => p.theme.sm.only(css`
    width: ${smWidth * totalItems + gap * (totalItems - 1)}px;
  `)}
  ${p => p.theme.xs(css`
    width: ${totalItems * 100}vh;
  `)}
  transition: 300ms;
`;

export const AttentionCard = styled.div`
    width: ${(lgWidth - gap) / lgVisibleItems}px;
    margin-right: ${gap}px;
    ${p => p.theme.md.only(css`
      width: ${(mdWidth - gap) / mdVisibleItems}px;
    `)}
    ${p => p.theme.sm.only(css`
      width: ${smWidth}px;
    `)}
    ${p => p.theme.xs(css`
      width: calc(100vw - 32px);
      margin-right: 32px;
    `)}
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow2};
    background-color: ${p => p.theme.c.cardBackground};
    ul {
      margin-bottom: 0;
      margin-top: 8px;
      padding-left: 24px;
    }
`;

export const IconRow = styled.div`
    text-align: center;
    color: ${p => p.theme.c.active};
    border-bottom: ${p => p.theme.c.info} solid 2px;
    margin-bottom: 12px;
    padding-bottom: 6px;
    span {
        font-size: 40px;
    }
`;

export const AttentionPager = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
`;

export const AttentionButton = styled.div`
    padding: 8px;
    margin: 4px;
    opacity: 0.4;
    &.Active {
        opacity: 1;
    }
    cursor: pointer;
    &.Last {
        ${p => p.theme.md.min(css`
            display: none;
        `)}
    }
`;

export const AttentionButtonInside = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${p => p.theme.c.active};
`;